import * as React from "react";
import { capitalize } from "lodash";
import { SocialNetworkMessage, socialNetworkNames } from "@/interfaces";
import moment from "moment";

interface OwnProps {
  socialNetwork: SocialNetworkMessage;
}

type Props = OwnProps;

/**
 * PostErrorCell Refactored to Tailwind and Lucide
 */
const PostErrorCellFC: React.FC<Props> = ({ socialNetwork }) => {
  const timestamp = socialNetwork.postedTimestamp || socialNetwork.createdDate;
  const isFailed = socialNetwork.status === "FAILED";

  return (
    <div className="flex flex-col gap-2 py-3 border-b border-slate-100 last:border-b-0 w-full text-left">
      <div className="flex items-center justify-between gap-4">
        {/* Left: Social Network Name & Timestamp */}
        <div className="flex flex-col gap-0.5">
          <span className="font-bold text-slate-800 text-sm">
            {socialNetworkNames[socialNetwork.socialNetworkId!!]}
          </span>
          <span className="text-[11px] text-slate-400 font-semibold select-none">
            {timestamp ? moment(timestamp).format("MM/DD/YYYY hh:mm a") : ""}
          </span>
        </div>

        {/* Right: Status Badge */}
        <span
          className={`text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full shadow-sm select-none shrink-0 ${
            isFailed
              ? "bg-red-50 text-red-600 border border-red-100"
              : "bg-green-50 text-green-600 border border-green-100"
          }`}
        >
          {capitalize(socialNetwork.status!!)}
        </span>
      </div>

      {/* Failed Reason under it if it exists */}
      {isFailed && socialNetwork.failedReason && (
        <div
          className="bg-red-50/50 border border-red-100/50 p-2.5 rounded-lg text-xs text-red-700 leading-normal line-clamp-3 select-text"
          title={socialNetwork.failedReason}
        >
          {socialNetwork.failedReason}
        </div>
      )}
    </div>
  );
};

export const PostErrorCell = PostErrorCellFC;
